import React from "react";
import Embers from "./Embers";

/**
 * Soft atmospheric blur transition between Boards (07) and Gallery (08).
 * No text, no harsh contrast — just a quiet, hazy warm strip.
 */
export default function TransitionBlur() {
  return (
    <div
      data-testid="transition-blur"
      aria-hidden="true"
      className="relative h-32 sm:h-40 lg:h-44 overflow-hidden bg-white"
    >
      {/* Blurred warm color wash — multiple soft radial blobs, no image */}
      <div
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(ellipse 60% 80% at 20% 50%, rgba(217,4,41,0.18) 0%, transparent 60%),
            radial-gradient(ellipse 50% 70% at 55% 55%, rgba(255,150,60,0.16) 0%, transparent 60%),
            radial-gradient(ellipse 55% 75% at 85% 45%, rgba(217,4,41,0.14) 0%, transparent 60%),
            linear-gradient(180deg, #FFFFFF 0%, #FBF6F1 50%, #FFFFFF 100%)
          `,
          filter: "blur(28px)",
          transform: "scale(1.1)",
        }}
      />

      {/* Top & bottom fade to white for seamless merging */}
      <div
        className="absolute inset-x-0 top-0 h-1/2"
        style={{
          background:
            "linear-gradient(to bottom, #FFFFFF 0%, rgba(255,255,255,0) 100%)",
        }}
      />
      <div
        className="absolute inset-x-0 bottom-0 h-1/2"
        style={{
          background:
            "linear-gradient(to top, #FFFFFF 0%, rgba(255,255,255,0) 100%)",
        }}
      />

      {/* Few drifting embers */}
      <Embers count={6} variant="light" />
    </div>
  );
}
